export default window.__VP_SITE_DATA__